import Signup from "../../../../jsx/pages/Connector/Signup";

const SignupWrapper = function (props) {
  return <Signup />;
};

export default constore(SignupWrapper);
